export default "__VITE_ASSET__asBS3OaJ__"